<template>
    <div>
        <el-tabs v-model="usable" tab-position="top" :closable="IsEnableLookFile" style="height: auto;" @tab-click="tabClick" @tab-remove="tabRemove">
            <el-tab-pane v-for="(tab,index) in tabs" :key="tab.FileName" :value="JSON.stringify(tab)" :name="tab.FileName" :label="tab.FileName">
            </el-tab-pane>

        </el-tabs>
        
        <!-- word文件预览 -->
        <div v-if="(usable.indexOf('.docx')!='-1'||usable.indexOf('.doc')!='-1')&&this.tabs.length!=0">
            <div style="margin-bottom: 10px;">
                <el-button  type="primary" icon="el-icon-download" @click="downFile"  circle></el-button>
            </div>
                    <div>
                        <vue-office-docx 
                    :src="docx"
                    style="height: 100vh;"
                    @rendered="renderedHandler"
                    @error="errorHandler"
                    />
                    </div>
        </div>
         <!-- Excel文件预览 -->
         <div v-else-if="usable.indexOf('.xlsx')!='-1'||usable.indexOf('.xls')!='-1'">
            <div style="margin-bottom: 10px;">
                <el-button  type="primary" icon="el-icon-download" @click="downFile"  circle></el-button>
            </div>
            <vue-office-excel
                :src="excel"
                :options="options"
                style="height: 100vh;"
                @rendered="renderedHandler"
                @error="errorHandler"
            />
        </div>
         <!-- PDF文件预览 -->
         <div v-else-if="usable.indexOf('.pdf')!='-1'">
            <div style="margin-bottom: 10px;">
                <el-button  type="primary" icon="el-icon-download" @click="downFile"  circle></el-button>
            </div>
            <vue-office-pdf 
        :src="pdf"
        style="height: 100vh"
        @rendered="renderedHandler"
        @error="errorHandler"
    />
        </div>
        <div v-else>
            <div style="margin-bottom: 10px;">
                <el-button v-if="tabs.length!=0"  type="primary" icon="el-icon-download" @click="downFile"  circle></el-button>
            </div>
        </div>

    </div>
</template>
  
<script>
import * as api from '../api/api';
import {getSelectDetaileFile,deleteFile,DownFiles} from "../api/EvaluationAgency/EvaluationAgency";


    export default {
        name: "LookDocument",
        components: {
    },
    props: ["itemId","IsEnableLookFile"], //接受父组件传值
    data() {
        return {
            options:{
                xls: false,       //预览xlsx文件设为false；预览xls文件设为true
                minColLength: 0,  // excel最少渲染多少列，如果想实现xlsx文件内容有几列，就渲染几列，可以将此值设置为0.
                minRowLength: 0,  // excel最少渲染多少行，如果想实现根据xlsx实际函数渲染，可以将此值设置为0.
                widthOffset: 30,  //如果渲染出来的结果感觉单元格宽度不够，可以在默认渲染的列表宽度上再加 Npx宽
                heightOffset: 60, //在默认渲染的列表高度上再加 Npx高
                beforeTransformData: (workbookData) => {return workbookData}, //底层通过exceljs获取excel文件内容，通过该钩子函数，可以对获取的excel文件内容进行修改，比如某个单元格的数据显示不正确，可以在此自行修改每个单元格的value值。
                transformData: (workbookData) => {return workbookData}, //将获取到的excel数据进行处理之后且渲染到页面之前，可通过transformData对即将渲染的数据及样式进行修改，此时每个单元格的text值就是即将渲染到页面上的内容
            },
            usable:"",
            files:null,
            tabs: [
            ],
            id:"",
            adress:api.BaseApiUrl+"/file/Down?",
            excel:'',
            pdf:'',
            docx: '' //设置文档网络地址，可以是相对地址
        }
    },
    created(){
        this.loadData();
    },
    mounted(){
        this.renderedHandler();
    },
    methods: {
        downFile()
        {
            console.log(this.files,this.files.length);
            if (this.files.length!=undefined) {
                this.files=this.files[0];
            }
            let parms={
                    "FileName": this.files.FileName,
                    "FilePath": this.files.FilePath
                    }
            DownFiles(parms).then((res)=>{
                console.log(res);
                // 处理blob数据
                const blob = new Blob([res], { type: 'application/octet-stream' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = this.files.FileName; // 设置下载文件名
                link.click();
            })
        },
        async loadData()
        {
            await this.load();
        },
        async load(){
            await getSelectDetaileFile({Id:this.itemId}).then((res)=>{
                if(res.success)
                {
                    this.tabs=res.response;
                    this.files=this.tabs;
                    if (this.tabs.length!=0) {
                        this.usable=this.tabs[0].FileName
                        console.log(this.usable);
                        this.id=this.tabs[0].Id;
                        if (this.usable.indexOf('.docx')!='-1'||this.usable.indexOf('.doc')!='-1') {
                            this.docx=`${this.adress}id=${this.tabs[0].Id}&filename=${encodeURIComponent(this.usable)}`;
                            console.log(this.docx,'1213123',encodeURIComponent(this.usable));
                        }
                        if (this.usable.indexOf('.xlsx')!='-1'||this.usable.indexOf('.xls')!='-1') {
                            this.excelChuli();
                            this.excel=`${this.adress}id=${this.tabs[0].Id}&filename=${encodeURIComponent(this.usable)}`;
                        }
                        if (this.usable.indexOf('.pdf')!='-1') {
                            this.pdf=`${this.adress}id=${this.tabs[0].Id}&filename=${encodeURIComponent(this.usable)}`;
                        }
                    }
                }
            });
        },
        tabClick(tab,event){
            console.log(tab,event,"dianji ");
            var fileName="";
            
            if(event==undefined)
            {
                this.files=tab;
                if (tab.label==undefined) {
                    fileName=this.files.FileName;
                }
            }
            else
            {
                let file=JSON.parse(tab.$attrs.value);
                this.files=file;
                fileName=tab.label;
                this.id=this.files.Id;
            }
            
            if (this.usable.indexOf('.docx')!='-1'||this.usable.indexOf('.doc')!='-1') {
                console.log("文档1",this.usable);
                this.docx=`${this.adress}id=${this.files.Id}&filename=${encodeURIComponent(fileName)}`;
            }
            if (this.usable.indexOf('.xlsx')!='-1'||this.usable.indexOf('.xls')!='-1') {
                console.log("文档2",this.usable);
                this.excelChuli();
                this.excel=`${this.adress}id=${this.files.Id}&filename=${encodeURIComponent(fileName)}`;
            }
            if (this.usable.indexOf('.pdf')!='-1') {
                console.log("文档3",this.usable);
                this.pdf=`${this.adress}id=${this.files.Id}&filename=${encodeURIComponent(fileName)}`;
                console.log(this.pdf);
            }
        },
         tabRemove(targetName,ev)
        {
            console.log(targetName,ev,"一处 ");
            let tabs = this.tabs;
            let removeData=tabs.filter(tab => tab.FileName == targetName);
            
            let parms={id:removeData[0].Id,filename:targetName};
            console.log(parms);
            //删除文件
             deleteFile(parms).then((res)=>{
                if(res.success)
                {
                    this.$message({
                    message: '删除文件成功！',
                    type: 'success'
                    });
                    console.log(removeData);
                    this.usable=targetName;
                    let activeName = this.usable;
                    if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.FileName === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeName = nextTab.FileName;
                        }
                        }
                    });
                    }
                    this.usable = activeName;
                    this.tabs = tabs.filter(tab => tab.FileName != targetName);
                    console.log(this.tabs);
                    if (this.tabs.length!=0) {
                        this.usable=this.tabs[0].FileName;
                        this.tabClick( this.tabs[0]);
                    }
                    else
                    {
                        this.docx="";
                        this.excel="";
                        this.pdf="";
                        this.usable="";
                    }

                }
                else
                {
                    this.$message({
                    message: '删除文件失败！',
                    type: 'warning'
                    });
                }
            });
        },
        excelChuli()
        {
            console.log(this.usable.split(','));
            let sz=this.usable.split(',');
            if (sz[1]==='xls') {
                this.options.xls=true;
            }
            else
            {
                this.options.xls=false;
            }
        },
        renderedHandler() {
            console.log("渲染完成")
        },
        errorHandler() {
            console.log("渲染失败")
        }
    }
    }
</script>

